function ModuleMap(mapContainer, options, strings){
	this.mapContainer = mapContainer;

	this.options = {
		'zoomLvl' : 14
	};

	// merge input options with default options
	for (let attrname in options) { this.options[attrname] = options[attrname]; }

	// default strings
	this.strings = {
		'planYourRoute' : 'Plan your route',
	};

	// merge input strings with default options
	for (let attrname in strings) { this.strings[attrname] = strings[attrname]; }

	// check for dependencies
	if(typeof google === 'undefined' || typeof google.maps === 'undefined'){
		console.warn('Google maps api not loaded.');
		return;
	}

	// binds
	this.parseLocation = this.parseLocation.bind(this);

	this.geocoder = new google.maps.Geocoder();

	this.parseLocationRequest = new XMLHttpRequest();
	this.parseLocationRequest.addEventListener('readystatechange', this.parseLocation);

	if(typeof this.options.ajaxUrlLocation != 'string'){
		console.warn('Cannot make ajax request, url not available or not wel formed.');
		return;
	}

	this.parseLocationRequest.open('GET', this.options.ajaxUrlLocation);
	this.parseLocationRequest.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
	this.parseLocationRequest.send();
}

ModuleMap.prototype.parseLocation = function(){
	if(this.parseLocationRequest.readyState != 4) return;
	if(this.parseLocationRequest.status != 200 && this.parseLocationRequest.status != 304) {
		console.error('HTTP error ' + this.parseLocationRequest.status);
		return;
	}
	
	this.locationData = JSON.parse(this.parseLocationRequest.responseText);

	if(this.locationData){
		const address = this.locationData.address + ' ' + this.locationData.postcode + ' ' + this.locationData.locality;

		this.geocoder.geocode( { 'address': address }, function(results, status){
			if(status !== 'OK'){
				console.warn('No geocoding results');
				return;
			}
			// TODO: check validity
			this.locationData.location = results[0].geometry.location;
			this.setupMap();
		}.bind(this));
	}
}

ModuleMap.prototype.setupMap = function(){
	var styles = [
		{
			"featureType": "poi",
			"elementType": "labels",
			"stylers": [
			{ "visibility": "off" }
			]
		},
		{
			"stylers": [
			{ "lightness": 35 },
			{ "saturation": -100 }
			]
		},
		{
			"featureType": "landscape"
		}
	];

	var styledMap = new google.maps.StyledMapType(styles, {name: "Styled Map"});

	var mapOptions = {
		zoom: this.options.zoomLvl,
		disableDefaultUI: false,
		scrollwheel: false,
		mapTypeControl: false,
		streetViewControl: false,
		panControl: true,
		center: this.locationData.location,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
	};

	this.googleMap = new google.maps.Map(this.mapContainer, mapOptions);

	this.googleMap.mapTypes.set('map_style', styledMap);
	this.googleMap.setMapTypeId('map_style');	

	this.locationMarker = new google.maps.Marker({
		position: this.locationData.location,
		icon: {
			url: this.locationData.locationMarkerIconSrc,
			scaledSize: new google.maps.Size(50, 50),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(25, 25)
		},
		title: this.locationData.name
	});

	let content = '<div class="location-infowindow"><strong>' + this.locationData.name + '</strong><br />' + this.locationData.address + '<br />' + this.locationData.postcode + ' ' + this.locationData.locality;

	content += '<a class="location-infowindow-route" target="_blank" rel="noopener" href="https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(this.getAddressQueryString(this.locationData)) +'">' + this.strings.planYourRoute + '</a>';

	content += '</div>';

	this.locationInfowindow = new google.maps.InfoWindow({
		content: content
	});

	this.locationMarker.setMap(this.googleMap);

	this.locationMarker.addListener('click', function(){
		this.locationInfowindow.open(this.googleMap, this.locationMarker);
	}.bind(this));

	this.locationInfowindow.open(this.googleMap, this.locationMarker);
}

ModuleMap.prototype.getAddressQueryString = function(locationData){
	return locationData.name + ' ' + locationData.address + ' ' + locationData.postcode + ' ' + locationData.locality;
}

export default ModuleMap;